"use strict";

var _objectSpread = require("/codebuild/output/src2429405957/src/github.com/wobicom/wobi-web-auto/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _formik = require("formik");
var _core = require("@material-ui/core");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _colors = require("../config/colors.config");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    disabled: {
      color: _colors.Black[150]
    },
    error: {
      marginBottom: 5
    },
    inlineLabel: function inlineLabel(overriddenStyles) {
      return _objectSpread({
        '& label': {
          marginRight: 20
        },
        alignItems: 'center',
        display: 'flex',
        fleDirection: 'row'
      }, overriddenStyles.inlineLabel);
    },
    label: {
      color: theme.palette.text.secondary,
      fontSize: theme.typography.fontSize,
      fontWeight: 500
    },
    marginBottom: {
      display: 'block',
      marginBottom: 20
    }
  };
});
var EzFormControl = function EzFormControl(props) {
  var _props$titleOnLabel = props.titleOnLabel,
    titleOnLabel = _props$titleOnLabel === void 0 ? '' : _props$titleOnLabel,
    children = props.children,
    name = props.name,
    label = props.label,
    labelFor = props.labelFor,
    _props$isLabelInChild = props.isLabelInChild,
    isLabelInChild = _props$isLabelInChild === void 0 ? false : _props$isLabelInChild,
    _props$isInputLabel = props.isInputLabel,
    isInputLabel = _props$isInputLabel === void 0 ? false : _props$isInputLabel,
    _props$isInlineLabel = props.isInlineLabel,
    isInlineLabel = _props$isInlineLabel === void 0 ? true : _props$isInlineLabel,
    _props$labelWidth = props.labelWidth,
    labelWidth = _props$labelWidth === void 0 ? false : _props$labelWidth,
    _props$isCustomLabel = props.isCustomLabel,
    isCustomLabel = _props$isCustomLabel === void 0 ? false : _props$isCustomLabel,
    _props$showError = props.showError,
    showError = _props$showError === void 0 ? true : _props$showError,
    disabled = props.disabled,
    _props$overriddenStyl = props.overriddenStyles,
    overriddenStyles = _props$overriddenStyl === void 0 ? {} : _props$overriddenStyl,
    _props$formControlPro = props.formControlProps,
    formControlProps = _props$formControlPro === void 0 ? {} : _props$formControlPro;
  var classes = useStyles(overriddenStyles);
  var labelComp = false;
  if (label && !isLabelInChild) {
    if (isInputLabel) {
      labelComp = /*#__PURE__*/_react.default.createElement(_core.InputLabel, {
        id: "".concat(name, "-label"),
        className: "".concat(disabled ? classes.disabled : '')
      }, label);
    } else if (isCustomLabel) {
      labelComp = label;
    } else {
      labelComp = /*#__PURE__*/_react.default.createElement(_core.FormLabel, {
        className: "".concat(classes.label, " ").concat(isInlineLabel ? '' : classes.marginBottom),
        style: {
          width: labelWidth || 'auto'
        },
        htmlFor: labelFor,
        id: "".concat(name, "-label"),
        title: titleOnLabel ? titleOnLabel : null,
        "data-testid": "".concat(name, "-label-text")
      }, label);
    }
  }
  return /*#__PURE__*/_react.default.createElement(_core.FormControl, _extends({
    fullWidth: true
  }, formControlProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(isInlineLabel ? classes.inlineLabel : '')
  }, labelComp, _react.default.Children.map(children, function (child) {
    return /*#__PURE__*/_react.default.cloneElement(child, {
      label: isLabelInChild ? label : '',
      name: name
    });
  })), showError ? /*#__PURE__*/_react.default.createElement(_core.FormHelperText, {
    className: classes.error,
    error: true,
    "data-testid": "".concat(name, "-error-text"),
    role: "alert"
  }, /*#__PURE__*/_react.default.createElement(_formik.ErrorMessage, {
    name: name
  })) : false);
};
EzFormControl.propTypes = {
  ariaLabel: _propTypes.default.string,
  children: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool,
  formControlProps: _propTypes.default.object,
  isCustomLabel: _propTypes.default.bool,
  isInlineLabel: _propTypes.default.bool,
  isInputLabel: _propTypes.default.bool,
  isLabelInChild: _propTypes.default.bool,
  label: _propTypes.default.any,
  labelFor: _propTypes.default.string,
  labelWidth: _propTypes.default.any,
  name: _propTypes.default.string.isRequired,
  overriddenStyles: _propTypes.default.any,
  showError: _propTypes.default.bool,
  titleOnLabel: _propTypes.default.string
};
var _default = exports.default = EzFormControl;